/* Google avatars default to 96px (=s96-c) — ask for a crisp 1024px copy. */
export const hiResAvatar = (url) =>
  (url && url.includes('googleusercontent.com')) ? url.replace(/=s\d+(-c)?$/, '=s1024-c') : url;
